import { useTranslation } from 'react-i18next';
import Navigation from '../components/Navigation';
import { Trophy } from '@phosphor-icons/react';

const LastManStandingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background" data-testid="lms-page">
      <Navigation />
      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-24 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-accent/10 rounded-sm mb-6">
          <Trophy size={40} weight="bold" className="text-accent" />
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-white mb-4">
          {t('nav.lastManStanding')}
        </h1>
        <div className="inline-block bg-[#FFD700] text-black font-bold uppercase tracking-widest text-sm px-6 py-2 rounded-sm mb-6">
          {t('dashboardPromo.comingSoon')}
        </div>
        <p className="text-text-secondary text-lg max-w-md mx-auto">
          {t('lms.comingSoonDesc', 'Last Man Standing is coming soon. In the meantime, make your World Cup 2026 predictions!')}
        </p>
      </div>
    </div>
  );
};

export default LastManStandingPage;
